import { createSlice } from "@reduxjs/toolkit";
import data from '../../data.json'
// console.log(data.products)

const cartSlice = createSlice({
    name: "Cart",
    initialState: {
        cart: [],
        brandcart: [],
        brands: data.products,
        toalaQuantity: 1,

    },
    reducers: {
        addItem: (state, action) => {

            let find = state.cart.findIndex((item) => item.id === action.payload.id)
            if (find >= 0) {
                state.cart[find].quantity += 1;


            } else {
                state.cart.push(action.payload)
            }

        },
        removeItem: (state, action) => {

            state.cart = state.cart.filter((ele) => ele.id !== action.payload)
        },
        getproductItem: (state, action) => {

            state.brandcart = state.brands.filter((ele) => ele.brand === action.payload)
        },
        getcatagory: (state, action) => {
            state.brandcart = state.brandcart.filter((ele) => ele.category === action.payload)
        }
    }
});

export const { addItem, removeItem, getproductItem, getcatagory } = cartSlice.actions;

export default cartSlice.reducer;